import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sc-modal-footer',
    imports: [],
    templateUrl: './modal-footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalFooterComponent {}
